package com.partejar.app.feature.convite.data

data class ConviteAceiteDetails(
    val invitedName: String,
    val email: String,
    val workspaceName: String,
    val profileName: String,
    val professionalCategory: String,
    val expiresAt: String,
    val existingUser: Boolean
)

data class ConviteAceiteInput(val name: String, val password: String)

data class ConviteAceiteResult(
    val accessToken: String,
    val refreshToken: String,
    val workspaceId: Long
)

interface ConviteAceiteDataSource {
    suspend fun validate(token: String): ConviteAceiteDetails
    suspend fun accept(token: String, input: ConviteAceiteInput?): ConviteAceiteResult
}

class ConviteInvalidoException : Exception()
class ConviteAcessoException : Exception()
class ConviteIndisponivelException : Exception()
